import component from './filterButton.component'
import './filterButton.scss'

let module = angular.module('filterButton', [])
	.component('filterButton', component)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/filterButton/filterButton.js